<div class="dialog-container">
  <mat-card class="no-shadow">
    <mat-card-header class="title">
      <mat-card-title class="no-subtitle">Duty Summary</mat-card-title>
      <button mat-icon-button color="primary" (click)="onCloseDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-header>

    <mat-card-content>
      <app-data-box headerTitle="On Duty" class="mt-32">
        <div class="data-box-content text-sm">
          The total scheduled or actual time from sign-in thru debrief for this duty period.
        </div>
      </app-data-box>

      <app-data-box headerTitle="FDP" class="mt-24">
        <div class="data-box-content text-sm">
          <div>Flight Duty Period (FAA Part 117).</div>
          <ul>
            <li>Starts at sign-in and ends at block-in of last flight.</li>
            <li>Does not include debrief.</li>
            <li>Does not include deadhead if the deadhead is the last or only leg.</li>
          </ul>
          <a href="https://www.alliedpilots.org/-/media/AlliedPilots/Member/Committee/FTDT/GEN/Docs/FAR-117-Guidance/FAR117-Quick-Reference-Guide_24SEPT2018.pdf"
            target="_blank" class="link text-sm">
            <mat-icon [inline]="true">launch</mat-icon>
            FAR 117 Quick Reference
          </a>
        </div>
      </app-data-box>
    </mat-card-content>
  </mat-card>
</div>